// IMPORT PACKAGE REFERENCES

import { combineReducers } from 'redux';


// IMPORT REDUCERS
import { UserReducer } from './UserReducer';
import { SegmentReducer } from './SegmentReducer';
import { EquipmentReducer } from './EquipmentReducer';
import { ProductReducer } from './ProductReducer';
import { PlanogramReducer } from './PlanogramReducer';
import { CategoryReducer } from './CategoryReducer';
import { StickerReducer } from './StickerReducer';


// EXPORT APP REDUCER

export const AppReducer = combineReducers({
    userReducer: UserReducer,
    productReducer: ProductReducer,
    segmentReducer: SegmentReducer,
    equipmentReducer: EquipmentReducer,
    planogramReducer: PlanogramReducer,
    categoryReducer: CategoryReducer,
    stickerReducer: StickerReducer
});


// WEBPACK FOOTER //
// ./src/components/state/reducers/AppReducer.js